import script from "./SkeletonHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletonHeader.vue?vue&type=script&setup=true&lang=js"

import "./SkeletonHeader.vue?vue&type=style&index=0&id=6bea5970&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bea5970"]])

export default __exports__